export default __webpack_public_path__ + "static/media/rx570.a19d2819.jpg";